import parse from "html-react-parser";
import { TextareaElementType } from "../helpers/types";

type Props = {
    value: string;
    onChange: (value: string) => void;
    error: string | null;
    disabled?: boolean;
}

const Textarea = (props: TextareaElementType & Props) => {
    const { value, onChange, error, placeholder, disabled, maxLength, label, description } = props;

    const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        onChange(e.target.value);
    };

    const lengthError = maxLength && value && value.length > maxLength ? `<p>${label} må inneholde mindre enn ${maxLength} tegn</p>` : null;

    return (
        <>
            <label className="form-label">{label}</label>
            {description && <div className="text-muted small mb-2">{parse(description)}</div>}
            <textarea
                value={value}
                name={label}
                onChange={handleChange}
                className={`form-control w-100 ${lengthError || (error && value) ? 'is-invalid' : value ? 'is-valid' : ''}`}
                rows={5}
                placeholder={placeholder}
                disabled={disabled}
            />
            <div className="row">
                <div className="col">
                    {(lengthError || (error && value)) && (
                        <div className="invalid-feedback" style={{display: 'block'}}>{parse(error || lengthError!)}</div>
                    )}
                </div>
                {maxLength && (
                    <div className="col-auto">
                        <span className="small text-muted">{value.length} / {maxLength}</span>
                    </div>
                )}
            </div>
            
        </>
    )
}

export default Textarea;